export enum ProductWishListEvent {
    GET_ALL_PRODUCT = 'productWishList:product:getAll',
    PUBLISH_ALL_PRODUCT = 'productWishList:product:publishAll',
    ADD_PRODUCT = 'productWishList:product:add',
    REMOVE_PRODUCT = 'productWishList:product:remove',
}
